import { render, staticRenderFns } from "./TickerAdminEditCompany.vue?vue&type=template&id=10b898fa&scoped=true"
import script from "./TickerAdminEditCompany.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditCompany.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminEditCompany.vue?vue&type=style&index=0&id=10b898fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b898fa",
  null
  
)

export default component.exports